import { render } from "./VinylRecord.vue?vue&type=template&id=6b405314&scoped=true"
const script = {}

import "./VinylRecord.vue?vue&type=style&index=0&id=6b405314&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/simple-city-site/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b405314"]])

export default __exports__